import { useEffect } from 'react';

import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { ApplicationIberiaCardsStep } from '@/components/modules/Application/IberiaCards/_shared/types/ApplicationIberiaCardsStep';
import { SalePointAndProduct } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/components/SalePointAndProduct';
import { ShortContactForm } from '@/components/modules/Application/IberiaCards/modules/ShortContactForm/components/ShortContactForm';
import { CustomPaper } from '@/components/shared/components/CustomPaper';

export const ApplicationIberiaCardsStands = () => {
  const { initApplication, resetApplicationContext, step, resetNavigation } = useApplicationNavigation();

  useEffect(() => {
    initApplication();

    resetNavigation([ApplicationIberiaCardsStep.SALE_POINT_AND_PRODUCT, ApplicationIberiaCardsStep.SHORT_CONTACT_FORM]);

    return () => {
      setTimeout(() => resetApplicationContext(), 100);
    };
  }, []);

  switch (step) {
    case ApplicationIberiaCardsStep.SALE_POINT_AND_PRODUCT:
      return <SalePointAndProduct />;
    case ApplicationIberiaCardsStep.SHORT_CONTACT_FORM:
      return <ShortContactForm />;
    default:
      return <CustomPaper loading={true} />;
  }
};
